import { Injectable } from '@angular/core';
import { Section } from '../models/section.model';
import { RendererSectionsRepository } from '../repositories/renderer-sections.repository';

@Injectable({ providedIn: 'root' })
export class RendererSectionsQuery {
  constructor(private rendererSectionsRepository: RendererSectionsRepository) {}

  getSectionWithKeyQuestion(key: string): Section {
    const sectionFiltered = this.rendererSectionsRepository
      .getAll()
      .filter((s) => s.questions.some((q) => q.key === key));
    if (sectionFiltered.length === 0) {
      return;
    } else if (sectionFiltered.length > 1) {
      throw `More than one question with key ${key}`;
    } else {
      return sectionFiltered[0];
    }
  }

  getSectionWithQuestionId(questionId: string): Section {
    return this.rendererSectionsRepository
      .getAll()
      .find((s) => s.questions.some((q) => q.id === questionId));
  }
}
